<div class="cuerpo">
    <div class="info">
        <p >{{nombre}}</p>
        <button class="button1" (click)="trasnferir()">Devolver a Sala</button>
        <button class="button2" (click)="desconectar()">Desconectar</button>
    </div>

</div>